import apiClient from "../api/apiClient";
import ENDPOINTS from "../api/endPoint";

export const createCustomer = (data) => {
  return apiClient(ENDPOINTS.CUSTOMER_ADD, {
    method: "POST",
    body: data,
  });
};

export const createRegisterCustomer = (data) => {
  return apiClient(ENDPOINTS.JKCUTOMREGISTER, {
    method: "POST",
    body: data,
    suppressToast: true,
  });
};

export const getCustomersBySellerId = (sellerId) => {
  return apiClient(ENDPOINTS.CUSTOMER_BY_SELLER(sellerId), {
    method: "GET",
  });
};

export const getAprrovalCustomersByUserId = (ID) => {
  return apiClient(ENDPOINTS.CUSTOMER_FOR_APPROVAL(ID), {
    method: "GET",
  });
};

export const getCreditLineCustomersByUserId = (ID) => {
  return apiClient(
    ENDPOINTS.CREDITLINE.FOR_APPROVAL(ID),
    {
      method: "GET",
    }
  );
};

// for existing customer api

export const getExistingCustomer = () => {
  return apiClient(ENDPOINTS.EXISTINGCUSTOMER, {
    method: "GET",
  });
};

export const createApprovalFlow = (data) => {
  return apiClient(ENDPOINTS.APPROVAL_FLOW_SUBMIT, {
    method: "POST",
    body: data,
  });
};

export const fetchAllCustomers = () => {
  return apiClient(ENDPOINTS.GET_ALL_CUSTOMERS, {
    method: "GET",
  });
};

export const getApprovalCustomerById = (customerId) => {
  return apiClient(
    ENDPOINTS.APPROVAL_STATUSES_BY_CUSTOMER(customerId),
    {
      method: "GET",
    }
  );
};

export const getAllApprovalStatusesByCustomerId = (customerId) => {
  return apiClient(
    ENDPOINTS.ALL_APPROVAL_STATUSES_BY_CUSTOMER(customerId),
    {
      method: "GET",
    }
  );
};

export const updateCustomerSeller = (custId, sellerId) => {
  return apiClient(ENDPOINTS.UPDATE_CUSTOMER_SELLER, {
    method: "PUT",
    body: { cust_Id: custId, sellerId },
  });
};

export const sendCredentialAPI = (customerId, accountNumber) => {
  return apiClient(
    ENDPOINTS.SEND_CUSTOMER_EMAIL(customerId, accountNumber),
    {
      method: "POST",
    }
  );
};

export const fetchAccountStatement = (id) => {
  return apiClient(
    ENDPOINTS.SAP.ACCOUNT_STATEMENT(id),
    {
      method: "GET",
    }
  );
};

export const fetchCustomerInvoices = (id) => {
  return apiClient(
    ENDPOINTS.SAP.CUSTOMER_INVOICE(id),
    {
      method: "GET",
    }
  );
};

export const fetchCreditNote = (id) => {
  return apiClient(ENDPOINTS.SAP.CREDIT_NOTE(id), {
    method: "GET",
  });
};

export const fetchCustomerPayment = (id) => {
  return apiClient(
    ENDPOINTS.SAP.PAYMENT_DETAILS(id),
    {
      method: "GET",
    }
  );
};

export const fetchAllCustomerPayments = (customerNo) => {
  return apiClient(ENDPOINTS.SAP.ACCOUNT_STATEMENT(customerNo), {
    method: "GET",
  });
};

export const fetchLogisticDetails = (id) => {
  return apiClient(
    ENDPOINTS.SAP.LOGISTIC_DETAILS(id),
    {
      method: "GET",
    }
  );
};

export const fetchCustomerDashboard = (id) => {
  return apiClient(ENDPOINTS.SAP.CUSTOMER_DASHBOARD(id), {
    method: "GET",
  });
};

export const updateCustomerGuaranteeType = (payload) => {
  return apiClient(ENDPOINTS.CUSTOMER_UPDATE_GUARANTEE, {
    method: "PUT",
    body: payload,
  });
};

export const Createcustomeraccess = (payload) => {
  return apiClient(ENDPOINTS.USER_SAVE_CUSTOMER_ACCESS, {
    method: "POST",
    body: payload,
  });
};

export const Updatecustomeraccess = (payload) => {
  return apiClient(ENDPOINTS.USER_UPDATE_CUSTOMER_ACCESS, {
    method: "PUT",
    body: payload,
  });
};

export const Deletecustomeraccess = (id) => {
  return apiClient(ENDPOINTS.USER_DELETE_CUSTOMER_ACCESS(id), {
    method: "DELETE",
  });
};

export const fetchCustomerAccess = () => {
  return apiClient(ENDPOINTS.USER_GET_CUSTOMER_ACCESS, {
    method: "GET",
  });
};



export const fetchCustomerDetails = () => {
  return apiClient(ENDPOINTS.CUSTOMER_COUNT_DASHBOARD, {
    method: "GET",
  });
};
